import { PurchaseOrderPaymentStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

// Each custom color is a CSS custom property declared in libs/webui/util/src/Status/StatusColor.scss; it resolves only in a browser that has loaded that stylesheet.
export const PurchaseOrderPaymentStatus = {
  unpaid: {
    value: PurchaseOrderPaymentStatusEnum.Unpaid,
    description: 'The item is still in cart',
    color: 'var(--status-custom-maroon)',
  },
  partiallyPaid: {
    value: PurchaseOrderPaymentStatusEnum.PartiallyPaid,
    description: 'The quotation for the order is added',
    color: 'var(--status-custom-orange)',
  },
  paid: {
    value: PurchaseOrderPaymentStatusEnum.Paid,
    description: 'The order is still being process/prepared',
    tone: StatusToneEnum.Active,
  },
  overPaid: {
    value: PurchaseOrderPaymentStatusEnum.OverPaid,
    description: 'The order preparation was done, and ready for payment from the buyer.',
    color: 'var(--status-custom-magenta)',
  },
}
